// Core imports
import { i18n } from '@/main'
import store from '@/store'
import { Notification } from 'element-ui'
import Vue from 'vue'
import Router from 'vue-router'
import EmailConfirmation from '../views/EmailConfirmation'
// Views imports
import Home from '../views/Home'
import PageNotFound from '../views/PageNotFound'
import PaymentConfirmation from '../views/PaymentConfirmation'
import YouSign from '../views/YouSign'
import auth from './auth'
import profile from './profile'
import records from './records'
import rentals from './rentals'
import residences from './residences'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    ...auth,
    ...residences,
    ...profile,
    ...records,
    ...rentals,
    {
      path: '/locations/:record_id/confirmation-de-signature-electronique',
      name: 'yousign',
      component: YouSign
    },
    {
      path: '/locations/:record_id/confirmation-du-paiement',
      name: 'payment-confirmation',
      component: PaymentConfirmation
    },
    {
      path: '/confirmation-email',
      name: 'email-confirmation',
      component: EmailConfirmation
    },
    {
      path: '*',
      name: 'null',
      component: PageNotFound
    }
  ]
})

/**
 * ScrollTop on page change
 */
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

/**
 * Router auth guard.
 *
 * Checks if the user is logged in before each route;
 * If the route has the meta `requiredAuth` set to true,
 * it will redirect the user to the login page.
 *
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiredAuth)) {
    // Check if the user is logged in
    if (!store.getters['auth/logged_in']) {
      next({
        path: '/connexion',
        query: { redirect: to.fullPath }
      })
    }
  }

  next()
})

/**
 * Tenants guard
 */
router.beforeEach((to, from, next) => {
  if (
    to.name === 'records-tenant' &&
    store.getters['records/currentRecord'] &&
    store.getters['records/currentRecord'].offer &&
    store.getters['records/currentRecord'].offer.unit_type.roomates_count ===
      store.getters['records/currentRecord'].tenant_ids.length
  ) {
    next({
      name: 'records-tenant-update',
      params: {
        id: store.getters['records/currentRecord'].id,
        tenant_id: store.getters['records/currentRecord'].tenant_ids[0]
      }
    })

    if (from.name === 'records-tenant-update') {
      Notification({
        type: 'error',
        title: i18n.t('base.errors.notificationTitle'),
        message: i18n.t('records.nav.cantCreateMore')
      })
    }
  } else {
    next()
  }
})

export default router
